import { FC } from 'react';
import { GroupHeader } from '@clds/menu-old';
import { ApplicationsGroupProps } from '../ApplicationsDropdownMenu.types';

export const ApplicationsDropdownGroup: FC<ApplicationsGroupProps> = ({ header, children }) => (
  <>
    <GroupHeader>{header}</GroupHeader>
    {children}
  </>
);
